import { nanoid } from "nanoid";
import React from "react";
import * as Bootstrap from "react-bootstrap";
import "../styles/Modal.css";

interface Props {
  children?: React.ReactNode;
  headerText?: string | null;
  onClose?: () => void;
  visible?: boolean;
  size?: "lg" | "sm" | "xl";
  centered?: boolean;
  style?: React.CSSProperties;
}

const Modal = ({
  children,
  headerText,
  onClose,
  visible,
  size,
  centered,
  style,
}: Props) => {
  const id = nanoid();
  return (
    <Bootstrap.Modal
      size={size}
      show={visible}
      onHide={onClose}
      aria-labelledby={id}
      centered={centered}
      style={style}
      dialogClassName="custom-modal"
    >
      <Bootstrap.Modal.Header>
        <Bootstrap.Modal.Title id={id}>{headerText}</Bootstrap.Modal.Title>
        <button
          type="button"
          className="btn-tool"
          aria-label="Close"
          onClick={onClose}
        >
          <i className="fas fa-times "></i>
        </button>
      </Bootstrap.Modal.Header>
      <Bootstrap.Modal.Body
        style={{ maxHeight: "70vh", overflow: "auto" }}
        className="modal-body-scrollbar"
      >
        {children}
      </Bootstrap.Modal.Body>
    </Bootstrap.Modal>
  );
};

export default Modal;
